const windowHeight = window.innerHeight;

const bodyHeight = document.querySelector("body").clientHeight;

const customFooterObjPc = document.getElementsByClassName("custom-footer-pc");

const customFooterObjSp = document.getElementsByClassName("custom-footer-sp");

const footerObj =
  customFooterObjPc[0].clientHeight > customFooterObjSp[0].clientHeight
    ? customFooterObjPc[0]
    : customFooterObjSp[0];

const footerObjPaddingBottom = parseInt(getComputedStyle(footerObj).paddingBottom, 10);

if (windowHeight > bodyHeight) {
  const heightSub = windowHeight - bodyHeight;
  footerObj.style.paddingBottom = `
    ${footerObjPaddingBottom + heightSub}px`;
}
